module.exports = __webpack_public_path__ + "img/imagen-ayudar.e0035349.png";